import React from "react";
import "./sub.css";
import Helmet from 'react-helmet'
import contactConfig from "../confi";
const TermsConditions = () => {
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  return (
<>
       <Helmet>
        <title>
          Terms & Conditions | JP Home Services – Maid, Cook & Caretaker Services
        </title>

        <meta
          name="description"
          content="Read the Terms & Conditions of JP Home Services. Learn about service scope, fees, replacement policy, client responsibilities, and legal terms for maid, cook, babysitter, and caretaker services in Ahmedabad."
        />

        <meta
          name="keywords"
          content="JP Home Services terms and conditions, maid service terms, home service agency terms, cook babysitter caretaker terms, domestic help agency policy, Ahmedabad home services terms"
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.jphomeservices.com/terms-conditions"
        />
        <meta property="og:title" content="Terms & Conditions | JP Home Services" />
        <meta
          property="og:description"
          content="Official Terms & Conditions of JP Home Services for maid, cook, babysitter & caretaker services."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.jphomeservices.com/terms-conditions" />

      </Helmet>
            <section className="about-hero">
            <div className="hero-content1">
                <h1>Terms & Conditions</h1>
            </div>
        </section>
    <div className="terms-conditions-container">
      <div className="floating-contact-icons">
            <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
              </svg>
            </div>
            <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
          </div>
      <div className="terms-conditions-content">
        <section className="terms-conditions-section">
          <div className="terms-section">
            <h2 className="section-title">1. Scope & Acceptance</h2>
            <div className="section-content">
              <p><strong>1.1</strong> These Terms govern your access to and use of our website [www.jphomeservices.com] (the "Website") and the related services we offer (the "Services").</p>
              <p><strong>1.2</strong> By registering, creating an account, booking a service, or otherwise using the Website or Services, you agree to these Terms, including any updates or modifications.</p>
              <p><strong>1.3</strong> We reserve the right at our sole discretion to amend or revise these Terms at any time. The revised Terms will be effective immediately upon posting on the Website (with a revised "Last Updated" date). Your continued use of the Website or Services following any such modification constitutes your acceptance of the revised Terms.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">2. Our Services</h2>
            <div className="section-content">
              <p><strong>2.1</strong> J P Home Services provides domestic and professional staffing services, including (but not limited to) maids, cooks, babysitters, drivers, patient caretakers, office staff, and other home-service personnel ("Personnel").</p>
              <p><strong>2.2</strong> We function as a placement / introduction agency: we introduce Personnel to you; you enter into an employment arrangement with that Personnel. We do not become the employer of the Personnel.</p>
              <p><strong>2.3</strong> You agree to pay all required fees, comply with placement terms, and assume responsibilities of an employer/client of the Personnel once engaged.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">3. Fees, Payment & Placement Terms</h2>
            <div className="section-content">
              <p><strong>3.1</strong> Our placement / recruitment fee is equal to one month's salary of the Personnel (or such other fee as communicated by us) plus any applicable GST or taxes.</p>
              <p><strong>3.2</strong> The salary of the Personnel begins from the date of their joining the assignment and must be paid directly by you on a monthly basis.</p>
              <p><strong>3.3</strong> The fee you pay to us is the recruitment/placement fee (for our services) and is non-refundable except as stated in these Terms.</p>
              <p><strong>3.4</strong> An invoice will be sent to you upon commencement of the Personnel's employment, and the placement fee is payable on or before the Personnel's joining date.</p>
              <p><strong>3.5</strong> Introductions provided by us are strictly confidential. If you introduce the Personnel to a third party (full-time or part-time) without our involvement or payment of placement charges, you agree to pay us the agreed placement charges.</p>
              <p><strong>3.6</strong> You must provide a clear job description (duties, working hours, salary) prior to placement. You cannot modify the job description or reduce salary post-placement. If the Personnel leaves due to any change outside the agreed job description or salary reduction, we will not be obligated to replace the Personnel nor refund any fees.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">4. Replacement Period & Cancellation</h2>
            <div className="section-content">
              <p><strong>4.1</strong> We offer a replacement period of six (6) months from the date of the Personnel's joining. Within this period, a maximum of three replacements may be provided.</p>
              <p><strong>4.2</strong> If you choose to cancel the employment contract for any reason during the replacement period, the placement/ service charges paid to us are non-refundable.</p>
              <p><strong>4.3</strong> If the Personnel is absent due to illness/family emergency but intends to rejoin within 10 days, no replacement will be given. If they fail to rejoin within 10 days, you may request a replacement.</p>
              <p><strong>4.4</strong> Should we be unable to provide a replacement within 15 days (after meeting replacement eligibility), and you choose to cancel, we may issue a credit note of the amount you paid, valid against future services with us.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">5. Client Obligations</h2>
            <div className="section-content">
              <p><strong>5.1</strong> You must pay the agreed salary to the Personnel monthly and provide a safe, respectful, lawful work environment.</p>
              <p><strong>5.2</strong> You agree to not torture, harass, harm (mentally or physically) the Personnel, or change the job description or reduce their salary. If the Personnel leaves for such reasons, we will not replace them nor refund fees.</p>
              <p><strong>5.3</strong> You will check any personal items (bags, purse etc.) the Personnel carries before they enter and before they leave your home.</p>
              <p><strong>5.4</strong> You are strongly advised to carry out a police verification of the Personnel. We will assist in the introduction, but we shall not be responsible for any civil or criminal wrongdoing by the Personnel.</p>
              <p><strong>5.5</strong> If you pay any advance salary or goods to the Personnel, you shall bear all risk. We are not responsible for recovery of such advances.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">6. No Refund or Guarantee of Salary Budget</h2>
            <div className="section-content">
              <p><strong>6.1</strong> You acknowledge that market salary expectations for Personnel change over time. We cannot guarantee replacement at the same salary rate. If you choose not to increase your salary budget, you cannot claim a refund.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">7. Limitation of Liability</h2>
            <div className="section-content">
              <p><strong>7.1</strong> While we endeavour to introduce suitably qualified Personnel, you agree that you are responsible for verifying the suitability of any Personnel before hiring (including medical, background checks).</p>
              <p><strong>7.2</strong> We shall not be responsible for any theft, injury, damage, misconduct, or other loss caused by the Personnel.</p>
              <p><strong>7.3</strong> Our liability is strictly limited to what is provided under these Terms; to the maximum extent permitted by law, we exclude all implied warranties or conditions.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">8. Intellectual Property</h2>
            <div className="section-content">
              <p><strong>8.1</strong> All content on the Website (text, images, logos, design) is the property of J P Home Services or its licensors and is protected by applicable intellectual property laws.</p>
              <p><strong>8.2</strong> You may not reproduce, distribute, modify or transmit any part of the Website or content without our prior written consent.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">9. Confidentiality</h2>
            <div className="section-content">
              <p><strong>9.1</strong> Any information shared by us about Personnel (resumes, profiles, data) is confidential. You agree not to share this information with third parties or use it for direct hiring without our involvement.</p>
              <p><strong>9.2</strong> Breach of confidentiality may result in your liability for the full placement fee as if you had hired via our services.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">10. Termination</h2>
            <div className="section-content">
              <p><strong>10.1</strong> We reserve the right to suspend or terminate your access to the Website and/or Services at our discretion, if you breach these Terms or behave inappropriately towards our staff or Personnel.</p>
              <p><strong>10.2</strong> Termination shall not relieve you of any payment obligations incurred prior to termination.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">11. Governing Law & Jurisdiction</h2>
            <div className="section-content">
              <p><strong>11.1</strong> These Terms shall be governed by and construed in accordance with the laws of India.</p>
              <p><strong>11.2</strong> All disputes arising in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in Ahmedabad, Gujarat, India (or such city where our registered office is situated).</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">12. Entire Agreement</h2>
            <div className="section-content">
              <p><strong>12.1</strong> These Terms together with our Privacy Policy (link) and any other policy referenced herein constitute the entire agreement between you and us regarding your use of the Website and Services and supersede all prior agreements, understandings, negotiations and discussions.</p>
            </div>
          </div>

          <div className="divider"></div>

          <div className="terms-section">
            <h2 className="section-title">13. Contact Information</h2>
            <div className="section-content">
              <p>If you have any questions or concerns regarding these Terms, please contact us:</p>
              <div className="contact-info1">
                <div className="contact-item1">
                  <span className="contact-icon1">📞</span>
                  <span className="contact-text1">{contactConfig.phone}</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon1">📧</span>
                  <span className="contact-text1">{contactConfig.email}</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon1">🏢</span>
                  <span className="contact-text1">JP Home Services,B-318, Swaminarayan Avenue,Nr. AEC Cross Road, Naranpura, Ahmedabad, Gujarat - 380013</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</>
  );
};

export default TermsConditions;